import { render } from "./InfoMessage.vue?vue&type=template&id=2943515d&scoped=true"
import script from "./InfoMessage.vue?vue&type=script&lang=js"
export * from "./InfoMessage.vue?vue&type=script&lang=js"

import "./InfoMessage.vue?vue&type=style&index=0&id=2943515d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2943515d"]])

export default __exports__